module.exports = __webpack_public_path__ + "static/media/S31_black.d83d4db9.png";